"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSumIfDatasourceConfigRequest = exports.isSumIfDatasourceConfig = void 0;
const isSumIfDatasourceConfig = (cfg) => {
    return (cfg !== null &&
        'group_by' in cfg &&
        'values' in cfg &&
        (cfg.group_by.length === 0 ||
            cfg.group_by[0]['column_id'] !== undefined));
};
exports.isSumIfDatasourceConfig = isSumIfDatasourceConfig;
const isSumIfDatasourceConfigRequest = (cfg) => {
    return 'group_by' in cfg && 'values' in cfg;
};
exports.isSumIfDatasourceConfigRequest = isSumIfDatasourceConfigRequest;
